import { render, staticRenderFns } from "./CompanyNotFound.vue?vue&type=template&id=f91d27a0"
import script from "./CompanyNotFound.vue?vue&type=script&lang=js"
export * from "./CompanyNotFound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports